import Image from 'next/image';

export const FDUSD = (props: { width: number; height: number }) => {
  return (
    <Image src="/images/token/FDUSD.png" alt="FDUSD" width={props.width} height={props.width} />
  );
};
